import React from 'react';
import { TextField } from '@mui/material';

export const MaintenanceFutureFields: React.FC = () => {
  return (
    <TextField
      label="Odoo Work Order ID"
      value=""
      disabled
      placeholder="Coming Soon"
      fullWidth
      helperText="Future: Integration with Odoo work order system"
      sx={{
        '& .MuiInputBase-input': {
          color: 'text.disabled',
        },
        '& .MuiInputLabel-root': {
          color: 'text.disabled',
        },
      }}
    />
  );
};
